import { ALL_PLAYER_VISIBILITIES } from '../../../../types/pokerPlayerTypes';
import { parseInboundPayload } from '../../inbound';
import { booleanParser, numberParser, stringParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
import { playerAvatarParser } from './playerAvatarInboundUtils';
const genericPlayerPartDefinitions = [
    { name: 'isReconnectPending', parser: booleanParser },
    { name: 'sessionId', parser: stringParser },
    { name: 'isClientLoadDone', parser: booleanParser },
    { name: 'id', parser: numberParser },
    { name: 'isMttReady', parser: booleanParser },
    { name: 'name', parser: stringParser },
    { name: 'numChipsInBank', parser: numberParser },
    { name: 'score', parser: numberParser },
    { name: 'level', parser: numberParser },
    { name: 'avatar', parser: playerAvatarParser },
    { name: 'mttStartingChips', parser: numberParser },
    { name: 'isAdmin', parser: booleanParser },
    { name: 'isHelper', parser: booleanParser },
    { name: 'isSecretAdmin', parser: booleanParser },
    { name: 'isPowerPlayer', parser: booleanParser },
    { name: 'networkIconHtml', parser: stringParser },
    { name: 'playerVisibility', parser: playerVisibilityOrdinalParser }
];
export function genericPlayerParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, genericPlayerPartDefinitions);
}
export function playerVisibilityOrdinalParser(str) {
    return ALL_PLAYER_VISIBILITIES[Number(str)];
}
